import React, { useState, useEffect } from "react";
import "react-tabs/style/react-tabs.css";
import { faSearch, faSort, faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalf } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarRegular } from "@fortawesome/free-regular-svg-icons";
import { utilGetDocumentFilters } from "../../../util/UtilsFirebase";
import "./CalificacionesPedidos.css";
import { Table, Form, Pagination, Button, Modal } from "react-bootstrap";
// import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import moment from "moment";
import { useAuthContext } from "../../../hooks/useAuthContext";

export default function CalificacionesPedidos() {
  const { register } = useAuthContext();
  const [data, setData] = useState([]);
  const [dateRange] = useState([]);
  const [detalleOrden, setDetalleOrden] = useState([]);
  const [sortType, setSortType] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const elementsPerPage = 10;
  const getElementsForPage = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };
  const [filterText, setFilterText] = useState("");
  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };
  const filteredData = data.filter((item) => {
    const date = new Date(item.fecha.toDate());
    //console.log(dateRange)
    if (dateRange.dateRange) {
      //console.log(dateRange.dateRange[0]);
      //console.log(dateRange.dateRange[1]);
      return (
        item.number
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.user_name
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.ordenadoPor
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.status
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        (item.total
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) &&
          date >= dateRange.dateRange[0] &&
          date <= dateRange.dateRange[1])
      );
    } else {
      return (
        item.number
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.user_name
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.ordenadoPor
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.total
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.status.toString().toLowerCase().includes(filterText.toLowerCase())
      );
    }
  });

  function mostrarDetalles(item) {
    setDetalleOrden(item);
    setMostrarDetalle(true);
  }

  function renderStars(calificacion) {
    const stars = [];
    const roundedRating = Math.round(calificacion);

    for (let i = 1; i <= 5; i++) {
      if (i <= roundedRating) {
        stars.push(<FontAwesomeIcon key={i} icon={faStar} />);
      } else if (i - 0.5 === roundedRating) {
        stars.push(<FontAwesomeIcon key={i} icon={faStarHalf} />);
      } else {
        stars.push(<FontAwesomeIcon key={i} icon={faStarRegular} />);
      }
    }
    return stars;
  }

  useEffect(() => {
    const filtros = [
      { campo: "puesto", operador: "==", valor: register.id },
      { campo: "status", operador: "==", valor: "COMPLETADO" },
      //{ campo: 'fecha', operador: '>=', valor: startOfDay.toJSDate() }
    ];
    const fetchOrders = utilGetDocumentFilters("turnero", filtros);
    fetchOrders
      .then((fetchedOrders) => {
        //console.log(fetchedOrders);

        setData(
          fetchedOrders.filter(
            (row) =>
              row.resena !== null &&
              row.resena !== undefined &&
              row.resena !== ""
          )
        );
      })
      .catch((error) => {
        console.error("Error fetching orders:", error);
      });
  }, [register.id]);

  return (
    <div>
      <br />
      <h4 className="page-title">COMENTARIOS DE PEDIDOS</h4>
      <br />
      <br />
      <br />
      <div className="container">
        <>
          <div className="row">
            <div className="col-sm-3">
              <div className="input-group">
                <Form.Control
                  className="form-control border-end-0 border rounded-pill"
                  type="text"
                  aria-describedby="search-icon"
                  placeholder="Busqueda"
                  value={filterText}
                  onChange={handleFilterTextChange}
                />
                <span className="input-group-append">
                  <button
                    className="btn btn-outline-secondary bg-white border-start-0 border rounded-pill ms-n3"
                    type="button"
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </button>
                </span>
              </div>
            </div>

            <div className="col-lg-12 mrg-tbl">
              <Table striped bordered hover border="2">
                <thead>
                  <tr>
                    <th
                      onClick={() =>
                        setSortType(sortType === "asc" ? "desc" : "asc")
                      }
                    >
                      {" "}
                      <FontAwesomeIcon icon={faSort} /> Fecha
                    </th>
                    <th>No. Orden</th>
                    <th>Cliente</th>
                    <th>Total</th>
                    <th>Estatus</th>
                    <th>Reseña</th>
                    <th>Calificación</th>
                    <th>Ver orden</th>
                  </tr>
                </thead>
                <tbody>
                  {getElementsForPage(currentPage)
                    .sort()
                    .map((val, key) => {
                      return (
                        <tr key={key}>
                          <td>
                            {moment(val.fecha.toDate()).format("DD/MM/YYYY")}
                          </td>
                          <td>{val.number.toString()}</td>
                          <td>
                            {val.user_name ? val.user_name : "SIN NOMBRE"}
                          </td>
                          <td>{val.total.toFixed(2)}</td>
                          <td>{val.status}</td>
                          <td>{val.resena ? val.resena : "No dejo reseña"}</td>
                          <td>
                            {val.resena_calificacion}{" "}
                            {renderStars(val.resena_calificacion)}
                          </td>
                          <td>
                            <Button
                              variant="primary"
                              style={{
                                minWidth: "50px !important",
                                marginLeft: 20,
                              }}
                              onClick={() => {
                                mostrarDetalles(val);
                              }}
                            >
                              <FontAwesomeIcon icon={faBars} />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
              <Pagination>
                {Array.from({
                  length: Math.ceil(filteredData.length / elementsPerPage),
                }).map((page, index) => (
                  <Pagination.Item
                    key={index}
                    active={index + 1 === currentPage}
                    className={index + 1 === currentPage ? "btn-paginado" : ""}
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </div>
          </div>
        </>
      </div>
      <Modal
        show={mostrarDetalle}
        onHide={() => {
          setDetalleOrden([]);
          setMostrarDetalle(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Detalles de la Orden</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <strong>Atendio: </strong>
          {detalleOrden.atendio ? detalleOrden.atendio : ""}
          <br />
          <br /> */}
          <Table striped bordered hover border="2">
            <thead>
              <tr>
                <th>Platillo</th>
                <th>Costo</th>
                <th>Cantidad</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {detalleOrden.detalle
                ? detalleOrden.detalle.map((element) => {
                    return (
                      <tr>
                        <td>{element.name.toString()}</td>
                        <td>{parseFloat(element.costo).toFixed(2)}</td>
                        <td>
                          {element.cantidad ? element.cantidad : "SIN NOMBRE"}
                        </td>
                        <td>{element.total.toFixed(2)}</td>
                      </tr>
                    );
                  })
                : ""}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setDetalleOrden([]);
              setMostrarDetalle(false);
            }}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
